var EPiCookiePro = ( function EPiCookiePro() { 

	var activeGroups = '';
	var domainData = {};
	var cookieProEnabled = false;

	var ConsentCategories = {
		StrictlyNecessary: 'C0001',
		Performance: 'C0002',
		Functional: 'C0003',
		Targeting: 'C0004',
		SocialMedia: 'C0005'
	}

	function CheckCustomItems() {

		var cookieProElements = document.querySelectorAll('[cookiepro-check="true"]');
		var tagType = "";

		activeGroups = window.OnetrustActiveGroups;
		domainData = window.OneTrust.GetDomainData();

		for (var i = 0; i < cookieProElements.length; i++) {

		    var cookieProElement = cookieProElements[i];
		    tagType = cookieProElement.tagName;

		    var attributeSrc = '';
		    var attributeDataSrc = '';
		    var attributeType = '';
		    var attributeClass = '';

		    if(cookieProElement.attributes["src"] != null && typeof cookieProElement.attributes["src"] !== 'undefined') {
		    	attributeSrc = cookieProElement.attributes["src"].value;
		    }

		    if(cookieProElement.attributes["data-src"] != null && typeof cookieProElement.attributes["data-src"] !== 'undefined') {
		    	attributeDataSrc = cookieProElement.attributes["data-src"].value;
		    }

		    if(cookieProElement.attributes["type"] != null && typeof cookieProElement.attributes["type"] !== 'undefined') {
		    	attributeType = cookieProElement.attributes["type"].value;
		    }

		    if(cookieProElement.attributes["class"] != null && typeof cookieProElement.attributes["class"] !== 'undefined') {
		    	attributeClass = cookieProElement.attributes["class"].value;
		    }

		    var hostToCheck = attributeSrc;

		    if(attributeSrc === "") {
		    	hostToCheck = attributeDataSrc;
		    }

		    var optanonCategoryId = GetOptanonCategoryByHost(domainData, hostToCheck);

		    //If we can't get an optanonCategoryId from host, what do?
		    if(optanonCategoryId === '') {
		    	optanonCategoryId = ConsentCategories.StrictlyNecessary;
		    }

		    if(optanonCategoryId !== '' && attributeClass.indexOf('optanon-category-' + optanonCategoryId) === -1) {
		    	attributeClass = 'optanon-category-' + optanonCategoryId;
		    	cookieProElement.classList.add(attributeClass.trim());
		    }

		    //Set allowed cookie classes to correct attribute values.
		    if(activeGroups.indexOf(optanonCategoryId) > -1) {

		    	if(tagType === 'IFRAME') {

		    		if(attributeDataSrc !== '') {

		    			cookieProElement.setAttribute("src", attributeDataSrc);
		    		}

		    		cookieProElement.removeAttribute("cookiepro-check");
		    		cookieProElement.style.display = "block";

					var blockedMessageElement = document.getElementsByClassName("blocked-iframe-message");

					if(blockedMessageElement.length) {

						blockedMessageElement[i].style.display = "none";
		
					}

		    	}

		    	if(tagType === 'SCRIPT') {

		    		cookieProElement.attributes["type"].value = "text/javascript";
					cookieProElement.removeAttribute("cookiepro-check");
					cookieProElement.setAttribute("reload-script", "true");

		    	}

		    }

		}

		var reloadSrcElements = document.querySelectorAll('[reload-script="true"][src]');
		var reloadSrcElementsCount = 0;
		var currentSrcLoaded = 0;

		if (reloadSrcElements !== null && reloadSrcElements !== typeof 'undefined') {

			reloadSrcElementsCount = reloadSrcElements.length;

			for (var i = 0; i < reloadSrcElements.length; i++) {

				reloadSrcElements[i].parentNode.removeChild(reloadSrcElements[i]);

				if (reloadSrcElements[i].attributes["src"] != null && typeof reloadSrcElements[i].attributes["src"] !== 'undefined') {

					var scriptReplace = document.createElement('script');
					scriptReplace.type = 'text/javascript';
					scriptReplace.src = reloadSrcElements[i].attributes["src"].value;

					scriptReplace.addEventListener('load', function () {

						currentSrcLoaded++;

						if (currentSrcLoaded === reloadSrcElementsCount) {

							addInPageScripts();

						}

					});

					document.body.appendChild(scriptReplace);
				}

			}

		}

	}

	function addInPageScripts() {

		var reloadInPageElements = document.querySelectorAll('[reload-script="true"]:not([src])');

		if (reloadInPageElements !== null && reloadInPageElements !== typeof 'undefined') {

			for (var i = 0; i < reloadInPageElements.length; i++) {

				reloadInPageElements[i].parentNode.removeChild(reloadInPageElements[i]);

				var scriptReplace = document.createElement('script');
				scriptReplace.type = 'text/javascript';
				scriptReplace.innerHTML = reloadInPageElements[i].innerHTML;

				document.body.appendChild(scriptReplace);

			}

		}

	}

	function DisplayVideoOverlay(containerClass) {

		var containerElements = document.getElementsByClassName(containerClass);

		for (var i = 0; i < containerElements.length; i++) {

			var container = containerElements[i];

			if(container !== null && typeof container !== 'undefined') {

				var iFrameElements = container.getElementsByTagName("iframe");

				if(iFrameElements !== null && typeof iFrameElements !== 'undefined' && iFrameElements.length) {

					for (var j = 0; j < iFrameElements.length; j++) { 

						var iFrame = iFrameElements[j];
											
						if (iFrame.attributes["class"] != null && typeof iFrame.attributes["class"] !== 'undefined' && iFrame.attributes["class"].value.indexOf("optanon-category-") > -1) {

							var iFrameClass = iFrame.attributes["class"].value;
							var regex = /optanon-category-\w+/gm;
							var optanonMatches = iFrameClass.match(regex)

							if (optanonMatches != null && optanonMatches.length > 0) {

								var optanonClass = optanonMatches[0];
								var iFrameAllowed = IsCookieCategoryAllowed(optanonClass);
								var blockedMessageElement = container.getElementsByClassName("blocked-iframe-message");

								if (!iFrameAllowed) {

									iFrame.style.display = 'none';

									if (blockedMessageElement.length) {

										blockedMessageElement[0].style.display = "block";
									}
								}
								else {

									iFrame.style.display = 'block';

									if (blockedMessageElement.length) {
										blockedMessageElement[0].style.display = "none";
									}
								}
							}
						}

					}					

				}

			}	

		}

	}


	function IsCookieCategoryAllowed(cookieCategoryId) {

		var isCookieProEnabled = IsCookieProEnabled();

		if(isCookieProEnabled === 'false' || isCookieProEnabled === false) {
			return true;
		}

		if(cookieCategoryId.indexOf('optanon-category-') > -1) {

			cookieCategoryId = cookieCategoryId.replace("optanon-category-", "");

		}

		if(window.OnetrustActiveGroups !== null && typeof window.OnetrustActiveGroups !== 'undefined') {

			if(window.OnetrustActiveGroups.indexOf(cookieCategoryId) > -1) {

				return true;

			}

		}

		return false;

	}

	function IsCookieProEnabled() {

		var cookieProAttribute = document.querySelector('[data-cookiepro-enabled]');

		if(cookieProAttribute !== null && typeof cookieProAttribute !== 'undefined') {
			cookieProEnabled = cookieProAttribute.dataset.cookieProEnabled;
		}

		return cookieProEnabled;

	}

	function GetOptanonCategoryByHost(domainData, attributeSrc) {

		var optanonCategoryId = '';
		var hostName = getHostname(attributeSrc);

		if(domainData !== null && typeof domainData !== 'undefined' && attributeSrc !== '') {

			var domainGroups = domainData.Groups;

			if(domainGroups !== null && typeof domainGroups !== 'undefined') {

				for (var i = 0; i < domainGroups.length; i++) {

					var optanonGroup = domainGroups[i];

			        if( optanonGroup !== null && typeof optanonGroup !== 'undefined' )
			        {
			            var hostItem = optanonGroup.Hosts.filter( function( item ) {
			                return hostName.indexOf(item.HostName > -1);
			            } )[ 0 ];

			            if(hostItem !== null && typeof hostItem !== 'undefined') {
			            	optanonCategoryId = optanonGroup.OptanonGroupId;
			            }
			        }

				}

			}

		}

		return optanonCategoryId;

	}

	function getHostname(url) {

	    var hostname = '';
	    
	    if (url.indexOf("//") > -1) {
	        hostname = url.split('/')[2];
	    }
	    else {
	        hostname = url.split('/')[0];
	    }

	    hostname = hostname.split(':')[0];
	    hostname = hostname.split('?')[0];

	    return hostname;
	}

    return {
        CheckCustomItems: CheckCustomItems,
        DisplayVideoOverlay: DisplayVideoOverlay,
        IsCookieCategoryAllowed: IsCookieCategoryAllowed,
        ConsentCategories: ConsentCategories
    };

}() );


//# sourceMappingURL=epicookiepro.js.map
